import { Outlet } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { MobileShippingBar } from "@/components/MobileShippingBar";

const Layout = () => (
  <div className="App bg-background">
    <Header />
    <MobileShippingBar />
    <main className="flex-1">
      <Outlet />
    </main>
    <Footer />
  </div>
);

export default Layout;
